
import { supabase } from '@/integrations/supabase/client';
import { Subscription } from '@/lib/data';

export async function updateSubscription(
  subscriptionId: string, 
  data: Partial<Subscription>
): Promise<Subscription> {
  console.log('Updating subscription with ID:', subscriptionId);
  console.log('Update data:', data);

  // Create a clean payload without unsupported fields
  const updatePayload: Partial<Subscription> = { ...data };
  
  // Make sure we don't try to update updated_by field
  if ('updated_by' in updatePayload) {
    delete updatePayload.updated_by;
  }

  // Handle termination_date and activation_date based on status
  if (updatePayload.status === 'terminated' && !updatePayload.termination_date) {
    updatePayload.termination_date = new Date().toISOString();
  }
  
  // If changing to active status, ensure activation_date is set
  if (updatePayload.status === 'active' && !updatePayload.activation_date) {
    updatePayload.activation_date = new Date().toISOString();
  }

  // Ensure prom_avarn is properly handled
  if ('prom_avarn' in updatePayload) {
    console.log('PROM Avarn value being sent in update:', updatePayload.prom_avarn);
  } else {
    console.log('Warning: prom_avarn missing from update data');
  }

  // Ensure invoice_reference is properly handled even if it's null or empty string
  if ('invoice_reference' in updatePayload) {
    console.log('Invoice reference being sent in update:', updatePayload.invoice_reference);
  } else {
    console.log('Warning: invoice_reference missing from update data');
  }

  // Send update to Supabase
  const { data: updatedSubscription, error } = await supabase
    .from('subscriptions')
    .update(updatePayload)
    .eq('subscription_id', subscriptionId)
    .select('*')
    .single();

  if (error) {
    console.error('Error updating subscription:', error);
    throw new Error(error.message);
  }

  if (!updatedSubscription) {
    throw new Error('Failed to update subscription');
  }

  console.log('Successfully updated subscription, result:', updatedSubscription);
  return updatedSubscription as Subscription;
}
